import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import Cookie from 'js-cookie';
import { saveUser, getUser, deleteUser } from '../../services/db';

type useContextProps = {
    children: ReactNode;
};

type authContextType = {
    user:
        | {
        id: string;
        created_at?: string;
        updated_at?: string;
        deleted_at?: string;
        cpf?: string;
        email: string;
        name: string;
        phone: string;
        profile: number;
        type: number;
        google_calendar_id?: string;
        associable_id: number;
        associable_type: string;
        permissions: Record<string, boolean>;
    }
        | null
        | undefined;
    setUser: (newState: any | undefined) => void;
    logout: () => void;
};

const initialValue: authContextType = {
    user: undefined,
    setUser: () => {},
    logout: () => {},
};

export const AuthContext = createContext<authContextType>(initialValue);

export function useAuth() {
    return useContext(AuthContext)!;
}

export const AuthContextProvider = ({ children }: useContextProps) => {
    const [user, setUser] = useState<any>(undefined);
    // const navigate = useNavigate();

    useEffect(() => {
        // Setup interceptor
        api.interceptors.request.use(async (config) => {
            const token = Cookie.get('authentication');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        });

        async function loadUser() {
            const token = Cookie.get('authentication');
            if (!token) {
                setUser(null);
                await deleteUser();
                return;
            }

            if (navigator.onLine) {
                try {
                    const response = await api.get('/provider/auth/user');
                    if (response.status === 200) {
                        setUser(response.data);
                        await saveUser(response.data);
                    } else {
                        setUser(null);
                        await deleteUser();
                        Cookie.remove('authentication');
                    }
                } catch {
                    setUser(null);
                    await deleteUser();
                    Cookie.remove('authentication');
                }
            } else {
                const storedUser = await getUser();
                if (storedUser) {
                    setUser(storedUser);
                } else {
                    setUser(null);
                }
            }
        }

        loadUser();
    }, []);

    const logout = async () => {
        setUser(null);
        await deleteUser();
        Cookie.remove('authentication');
        // navigate('/login');
        window.location.href = '/login';
    };

    return (
        <AuthContext.Provider value={{ user, setUser, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
